import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const subscriptionApi = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('SMARTCAF-AUTH-USER')
        ? JSON.parse(localStorage.getItem('SMARTCAF-AUTH-USER')).token
        : null

      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  tagTypes: ['Subscription'],
  endpoints: (builder) => ({
    getSubscription: builder.query({
      query: () => '/user/subscription',
      providesTags: ['Subscription'],
    }),
    getSubscriptionServices: builder.query({
      query: () => '/user/subscription/services',
      providesTags: ['Subscription'],
    }),
  }),
})

export const { useGetSubscriptionQuery, useGetSubscriptionServicesQuery } =
  subscriptionApi
